import { permissionsSelector } from "../modules/Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { InputHTMLAttributes, DetailedHTMLProps, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ITextInputHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  pattern?: string;
  secondDiv?: string;
  value?: any;
}

const TextInputLabelPhone: React.FC<ITextInputHookForm> = ({
  className = "border border-gray-300",
  disabled = false,
  required = false,
  pattern = "(/(/d{3}/)) /d{3}[-]d{4}",
  placeholder = "(000) 000-0000",
  secondDiv = "grid-cols-1 md:grid-cols-3",
  register,
  title,
  label,
  onChange,
  value,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div
        className={`${label && "grid"} ${secondDiv} w-full items-center gap-1`}
      >
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}:
          </label>
        )}
        <input
          className={`block w-full px-1 py-1 rounded-sm bg-white ${
            disabled
              ? "opacity-50"
              : `${className} col-span-2 text-login bg-clip-padding leading-normal outline-none
               focus:ring-septenary focus:border-septenary`
          }`}
          {...register}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          type="tel"
          pattern={pattern}
          title={title}
          value={value}
        />
      </div>
    </div>
  );
};
export default TextInputLabelPhone;
